














import { Component, Prop, Vue } from "vue-property-decorator";
import EmptyDialogComponent from "@/components/common/parts/EmptyDialogComponent.vue";

@Component({
  components: {
    EmptyDialogComponent
  }
})
export default class DeleteDialogComponent extends Vue {
  @Prop({
    default: false
  })
  public display!: boolean;

  @Prop({
    default: "データを削除しますか？"
  })
  public title!: string;

  @Prop({
    default: ""
  })
  public body!: string;
}
